import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function EditProfileDialog({ open, onOpenChange, profile, onSaved }) {
  const [form, setForm] = useState({ bio: "", community: "", dm_privacy: "all" });
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setForm({ bio: profile.bio || "", community: profile.community || "", dm_privacy: profile.dm_privacy || "all" }); }, [open, profile]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/users/me/profile", form);
      onSaved(data);
      toast.success("Perfil atualizado");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="edit-profile-dialog">
        <DialogHeader><DialogTitle>Editar perfil</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Biografia</Label>
            <Textarea value={form.bio} maxLength={160} onChange={(e) => setForm({ ...form, bio: e.target.value })} placeholder="Conte um pouco sobre você e a sua fé…" data-testid="edit-profile-bio-input" />
            <p className="text-right text-[11px] text-muted-foreground">{form.bio.length}/160</p>
          </div>
          <div className="space-y-1.5">
            <Label>Comunidade / Igreja</Label>
            <Input value={form.community} maxLength={60} onChange={(e) => setForm({ ...form, community: e.target.value })} placeholder="Ex.: Paróquia São José" data-testid="edit-profile-community-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Quem pode enviar mensagens</Label>
            <Select value={form.dm_privacy} onValueChange={(v) => setForm({ ...form, dm_privacy: v })}>
              <SelectTrigger data-testid="edit-profile-dm-privacy-select"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="all">Todos</SelectItem><SelectItem value="following">Só quem eu sigo</SelectItem></SelectContent>
            </Select>
          </div>
          <p className="text-xs text-muted-foreground">O Guarda-Costas IA verifica o texto antes de salvar.</p>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={saving} className="rounded-full font-bold" data-testid="edit-profile-save-button">{saving ? "Salvando…" : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
